import React from 'react';
import { observer } from 'mobx-react-lite';
import { useQuoteSubscriberProfilePageStore } from 'store/pages/subscriber/quote-subscriber-profile/pageStore';
import { DynamicForm } from '@insurancemenu/imenu-components-lib';

const QuoteSubscriberProfileForm: React.FC = observer(() => {
  const { dynamicFormDelegate, isStepCompleted, returnBack } = useQuoteSubscriberProfilePageStore();

  return (
    <DynamicForm
      formDelegate={dynamicFormDelegate}
      completeButtonText={isStepCompleted ? 'Update' : 'Complete'}
      onBack={returnBack}
    />
  );
});

export default QuoteSubscriberProfileForm;
